module.exports = __webpack_public_path__ + "img/banner-prouni-2022-600x490-v2.8a2e3240.jpg";